import { render, staticRenderFns } from "./LookupUser.vue?vue&type=template&id=66c18946"
import script from "./LookupUser.vue?vue&type=script&lang=js"
export * from "./LookupUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports